import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import CallLogsSearchBox from "../components/CallLogsSearchBox";
import CallLogsPagination from "../components/CallLogsPagination";
import { useNavigate, useParams } from "react-router-dom";
import { Listbox, Transition } from "@headlessui/react";
import { fetchCustomer, fetchCustomerZoho } from "../api/customerRequest";
import Loader from "../components/Loader";
import { Toaster, ToastIcon, toast, resolveValue } from "react-hot-toast";
import ChangeNumberModal from "../components/ChangeNumberModal";
import axiosx from "../axios/index";
import { useQuery } from "react-query";
import SubmitModaSuburb from "../components/EditUserModel";
import { useDropdown } from "../store/dropdown-context";

const TailwindToaster = () => {
  return (
    <Toaster>
      {(t) => (
        <Transition
          appear
          show={t.visible}
          className="transform p-4 flex bg-white rounded shadow-lg"
          enter="transition-all duration-150"
          enterFrom="opacity-0 scale-50"
          enterTo="opacity-100 scale-100"
          leave="transition-all duration-150"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-75"
        >
          <ToastIcon toast={t} />
          <p className="px-2">{resolveValue(t.message)}</p>
        </Transition>
      )}
    </Toaster>
  );
};
const ContactScreen = () => {
  const [loadding, setLoadding] = useState(false);
  const [customer, setCustomer] = useState([]);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [redirect, setRedirect] = useState(0);
  const [openUserEditModal, setOpenUserEditModal] = useState(false);
  const [user, setUser] = useState({});
  let { phoneNumber, agentName } = useParams();
  const { agentNameContext, setAgentName, saveAgentName } = useDropdown();
  let navigate = useNavigate();
  window.scrollTo(0, 0);

  const getCustomer = async ({ queryKey }) => {
    try {
      setLoadding(true);

      const response = await axiosx
        .get(`/ticket/contacts/${queryKey[1]}`)
        .catch((err) => {
          console.log(err);
          setLoadding(false);
        });
      if (response?.data?.success === false) {
        if (response?.data?.error?.response?.status == 404) {
          // toast.error('لا يوجد بيانات لعرضها');
          // navigate(`/IncomingCallScreen/${phoneNumber}`);
          toast.error("حدث خطأ ما");
          setLoadding(false);
        }
      }
      if (response?.data?.success === true) {
        if (response?.data?.data?.length > 0) {
          toast.success("تم تحميل البيانات بنجاح");
          setLoadding(false);
          // console.log(response.data.data);
          return response.data.data;
        } else {
          toast.error("لا يوجد بيانات لعرضها");
          // navigate(`/IncomingCallScreen/${phoneNumber}`);
          setLoadding(false);

          return [];
          // setRedirect((prevState) => prevState + 1);
        }
      } else {
        toast.error("لا يوجد بيانات لعرضها");
        toast.error("حدث خطأ ما");
        setLoadding(false);

        return [];
        // navigate(`/IncomingCallScreen/${phoneNumber}`);
        // setLoadding(false);
      }
    } catch (error) {
      console.log(error);
    }
    setLoadding(false);
  };

  const { data, status, isPreviousData } = useQuery(
    ["customer", phoneNumber],
    getCustomer,

    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (err) => {
        console.log(err);
        setLoadding(false);
      },
    }
  );

  const handelEditUser = (user) => {
    setUser(user);
    setOpenUserEditModal(true);
  };

  useEffect(() => {
    console.log("agentName", agentName);
    if (
      agentName != null &&
      agentName != undefined &&
      agentName != "" &&
      agentName?.length > 0
    ) {
      if (localStorage.getItem("agentName") !== agentName) {
        saveAgentName(agentName);
      }
    } else {
      console.log(localStorage.getItem("agentName"), "localStorage");
      saveAgentName(localStorage.getItem("agentName"));
      navigate(`${localStorage.getItem("agentName")}`);
    }
  }, [phoneNumber, agentName]);

  // useEffect(() => {
  //   setLoadding(true);
  //   setError('');
  //   setRedirect(0);
  //   try {
  //     fetchCustomerZoho(phoneNumber)
  //       .then((data) => {
  //         if (data.success === false) {
  //           if (data.error.response.status == 404) {
  //             // toast.error('لا يوجد بيانات لعرضها');
  //             // navigate(`/IncomingCallScreen/${phoneNumber}`);
  //             toast.error('حدث خطأ ما');
  //           }
  //         }
  //         if (data?.data?.success === true) {
  //           if (data?.data?.data?.length > 0) {
  //             toast.success('تم تحميل البيانات بنجاح');
  //             setCustomer((prevState) => [data.data.data[0]]);
  //             setRedirect((prevState) => prevState + 3);
  //           } else {
  //             toast.error('لا يوجد بيانات لعرضها');
  //             // navigate(`/IncomingCallScreen/${phoneNumber}`);
  //             setRedirect((prevState) => prevState + 1);
  //           }
  //         } else {
  //           toast.error('لا يوجد بيانات لعرضها');
  //           toast.error('حدث خطأ ما');

  //           // navigate(`/IncomingCallScreen/${phoneNumber}`);
  //         }
  //       })
  //       .catch((err) => {
  //         // setError(err.message);

  //         toast.error('حدث خطأ ما');
  //       })
  //       .finally(() => {
  //         setLoadding(false);
  //       });
  //   } catch (error) {
  //     setError(error.message);
  //   }
  //   if (redirect >= 2) {
  //     // navigate(`/IncomingCallScreen/${phoneNumber}`);
  //     setRedirect(0);
  //   }
  // }, [phoneNumber]);

  return (
    <>
      {loadding || status === "loading" ? (
        <div
          className="bg-background-100 min-h-screen h-full flex  w-full align-middle mx-auto justify-center items-center"
          dir="rtl"
        >
          <Loader />
        </div>
      ) : (
        <div className="bg-background-100 min-h-screen flex flex-col" dir="rtl">
          {
            <ChangeNumberModal
              open={open}
              setOpen={setOpen}
              setError={setError}
            />
          }
          {
            <SubmitModaSuburb
              setOpenCustomer={setOpenUserEditModal}
              openCustomer={openUserEditModal}
              user={data[0]}
              phoneNumber={data[0]?.phoneLocal}
            />
          }
          <div className="max-w-2xl w-screen mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8 ">
            <h2 className="text-2xl font-extrabold tracking-tight text-title-100 text-center pb-6">
              حسابات الزبون
            </h2>
            <div className="   flex flex-row ">
              <p className="text-title-100 text-xl pl-4 align-middle flex">
                اسم المستخدم : {agentNameContext}
              </p>
            </div>
            <div>
              <CallLogsSearchBox />
            </div>

            <div className="mt-6 flex flex-col space-y-14 pl-20">
              <div className="flex justify-between items-center">
                <div className="   flex flex-row ">
                  <p className="text-title-100 text-xl pl-4 align-middle flex">
                    رقم الهاتف : {phoneNumber}
                  </p>
                  <button onClick={() => setOpen(true)}>
                    <FontAwesomeIcon
                      icon={solid("pen-to-square")}
                      color="#7367F0"
                      size="xl"
                    />
                  </button>
                </div>

                <div className="  ">
                  <button
                    type="button"
                    onClick={() => navigate(`/CalLlogsScreen/${phoneNumber}`)}
                    className=" text-white bg-button-100 hover:bg-blue-800  rounded-md  font-medium  text-sm px-10 py-2     "
                  >
                    السجل
                  </button>
                </div>
              </div>
              <div
                className={`${data.length < 1 ? "" : "grid grid-cols-3 gap-4"}`}
              >
                {/* <div className=''> */}
                {data?.length < 1 ? (
                  <div className="flex justify-center pt-28">
                    <button
                      type="button"
                      onClick={() =>
                        navigate(`/IncomingCallScreen/${phoneNumber}`)
                      }
                      className=" text-white bg-button-100 hover:bg-blue-800  rounded-md  font-medium  text-sm px-10 py-2     "
                    >
                      الاستمرار
                    </button>
                  </div>
                ) : (
                  <div
                    key={data[0]?.accountCode}
                    className="  border-black shadow-2xl rounded-lg p-4  bg-white pt-8 px-8 w-full"
                  >
                    <div className=" flex flex-col">
                      <div>
                        <div className="flex flex-row justify-between pb-6 border-b-2 border-gray-300">
                          <h3 className="text-lg text-title-100  ">
                            {data[0]?.custName}
                          </h3>
                          {/* // on click open modal to change contact info and save it */}
                          {/* // on click open modal to change contact info and save it */}
                          {/* // on click open modal to change contact info and save it */}
                          <button onClick={() => handelEditUser(data[0])}>
                            <FontAwesomeIcon
                              icon={solid("pen-to-square")}
                              color="#7367F0"
                              size="xl"
                            />
                          </button>
                        </div>
                        <div className="mt-6 text-lg text-title-100 flex flex-row ">
                          <p>
                            <FontAwesomeIcon
                              icon={solid("phone-flip")}
                              color="#7367F0"
                              size="sm"
                            />
                          </p>
                          <p className=" text-lg text-title-100 pr-2 align-middle">
                            {data[0]?.phoneLocal}
                          </p>
                        </div>
                      </div>

                      <div className="mt-2 pb-6 text-lg text-title-100 flex flex-row ">
                        <p>
                          <FontAwesomeIcon
                            icon={solid("location-dot")}
                            color="#7367F0"
                            size="sm"
                          />
                        </p>
                        <p className=" text-lg text-title-100 pr-2 align-middle">
                          {data[0]?.stateId} - {data[0]?.city}
                        </p>
                      </div>
                      <div className="flex mx-auto">
                        <button
                          type="button"
                          onClick={() =>
                            navigate(`/IncomingCallScreen/${phoneNumber}`, {
                              state: {
                                account: data[0],
                              },
                            })
                          }
                          className="text-white bg-button-100 hover:bg-blue-800  rounded-md  font-medium  text-sm px-10 py-2 mb-2    "
                        >
                          الاستمرار
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <TailwindToaster />
        </div>
      )}
    </>
  );
};

export default ContactScreen;
